/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
export type creditApplicationDocumentFragment = { readonly __typename: 'CreditApplicationDocument', readonly documentType: _Types.CreditDocument, readonly documentUuid: string, readonly isReRequested: boolean, readonly statusMessage: string | null, readonly fileName: string | null, readonly status: string | null, readonly signedUrl: string | null, readonly unsignedPath: string | null };

export const creditApplicationDocumentFragment = gql`
    fragment creditApplicationDocumentFragment on CreditApplicationDocument {
  documentType
  documentUuid
  isReRequested
  statusMessage
  fileName
  status
  signedUrl
  unsignedPath
}
    `;